import getSubdomain from 'utils/getSubdomain';
import OmmnioAppIcon from 'assets/icons/ommnio-app-icon.svg';
import saintGobain from 'assets/icons/connectia-app-icon.svg';

const appIcons = {
  'saint-gobain': saintGobain,
};

const AppIcon = appIcons[getSubdomain()] || OmmnioAppIcon;

export default AppIcon;
